// @flow
import React from 'react';
import { connect } from 'react-redux';
import { components } from '@peachjar/components';

import SetupOrganizationContainer, {
  type ReduxStateProps,
  type ReduxDispatchProps,
} from './SetupOrganizationContainer';
import {
  setFlyerApprovalGuidelinesUrl,
  setStaffGroupFlyerNotificationPreference,
  setFlyerDisclaimerInclusionPreference,
  setFlyerDisclaimer,
  setOrganizationDenialContactInformation,
  saveOrganizationSettings,
  toggleOrganizationCommunicationDownloaded,
} from '../setup-organization.duck';

const {
  Notifications: { notifyError },
} = components;

const mapStateToProps = (state): ReduxStateProps => ({
  flyerApprovalGuidelinesUrl:
    state.organizationSetup.flyerApprovalGuidelinesUrl,
  isValidUrl: state.organizationSetup.isValidUrl,
  canSendFlyersToStaff: state.organizationSetup.canSendFlyersToStaff,
  flyerDisclaimerRequired: state.organizationSetup.flyerDisclaimerRequired,
  flyerDisclaimer: state.organizationSetup.flyerDisclaimer,
  organizationDenialContactInformation:
    state.organizationSetup.organizationDenialContactInformation,
  organizationCommunicationDownloaded:
    state.organizationSetup.organizationCommunicationDownloaded,
});

const mapDispatchToProps = (dispatch): ReduxDispatchProps => ({
  handleFlyerApprovalGuidelinesUrlChange: event => {
    dispatch(setFlyerApprovalGuidelinesUrl(event.target.value));
  },
  handleStaffGroupNotificationRadioSelectionYes: () => {
    dispatch(setStaffGroupFlyerNotificationPreference(true));
  },
  handleStaffGroupNotificationRadioSelectionNo: () => {
    dispatch(setStaffGroupFlyerNotificationPreference(false));
  },
  handleFlyerDisclaimerRequiredRadioSelectionYes: () => {
    dispatch(setFlyerDisclaimerInclusionPreference(true));
  },
  handleFlyerDisclaimerRequiredRadioSelectionNo: () => {
    dispatch(setFlyerDisclaimerInclusionPreference(false));
  },
  handleFlyerDisclaimer: event => {
    dispatch(setFlyerDisclaimer(event.target.value));
  },
  handleDenialContact: event => {
    dispatch(setOrganizationDenialContactInformation(event.target.value));
  },
  handleContinue: event => {
    dispatch(saveOrganizationSettings());
  },
  onNotifyError: error => {
    dispatch(notifyError(error.message));
  },
  handleOrganizationCommunicationDownloaded: () => {
    dispatch(toggleOrganizationCommunicationDownloaded(true));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetupOrganizationContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/organization/containers/index.jsx